import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/login.jpg'


const _hoisted_1 = { class: "m-auto m-1230" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "mw-480 ms-lg-auto" }
const _hoisted_5 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center",
  role: "alert"
}
const _hoisted_6 = {
  key: 1,
  class: "alert alert-danger d-flex align-items-center",
  role: "alert"
}
const _hoisted_7 = {
  key: 2,
  class: "alert alert-warning d-flex align-items-center",
  role: "alert"
}
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "form-floating mb-4" }
const _hoisted_10 = { class: "form-floating mb-4 position-relative" }
const _hoisted_11 = ["type"]
const _hoisted_12 = { class: "material-symbols-outlined" }
const _hoisted_13 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_14 = { class: "form-floating mb-4 position-relative" }
const _hoisted_15 = ["type"]
const _hoisted_16 = { class: "material-symbols-outlined" }
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_18 = { class: "form-group mb-4" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_21 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center py-1"
}
const _hoisted_22 = {
  key: 4,
  class: "text-center"
}
const _hoisted_23 = {
  key: 5,
  class: "form-group"
}
const _hoisted_24 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col-lg-6 d-none d-lg-block" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "rounded-3",
          alt: "reset password"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "fs-28 mb-2" }, "Imposta Nuova Password", -1)),
          _cache[24] || (_cache[24] = _createElementVNode("p", { class: "fw-medium fs-16 mb-4" }, " Inserisci la tua nuova password per completare il reset. ", -1)),
          _createElementVNode("form", {
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleResetPassword && _ctx.handleResetPassword(...args)), ["prevent"])),
            class: "auth-form"
          }, [
            (_ctx.successMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[10] || (_cache[10] = _createElementVNode("i", { class: "material-symbols-outlined me-2" }, "check_circle", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.successMessage), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.apiError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[11] || (_cache[11] = _createElementVNode("i", { class: "material-symbols-outlined me-2" }, "error", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.apiError), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.tokenError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[12] || (_cache[12] = _createElementVNode("i", { class: "material-symbols-outlined me-2" }, "warning", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.tokenError), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.resetCompleted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: "form-control h-55",
                      id: "resetEmail",
                      placeholder: "esempio@email.com",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.email]
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("label", { for: "resetEmail" }, "Indirizzo Email", -1))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.passwordFieldType,
                      class: _normalizeClass(["form-control h-55", { 'is-invalid': _ctx.passwordError }]),
                      id: "newPassword",
                      placeholder: "Nuova password",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validatePassword && _ctx.validatePassword(...args))),
                      onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validatePassword && _ctx.validatePassword(...args))),
                      required: ""
                    }, null, 42, _hoisted_11), [
                      [_vModelDynamic, _ctx.password]
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("label", { for: "newPassword" }, "Nuova Password", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn border-0 position-absolute top-50 end-0 translate-middle-y d-flex align-items-center justify-content-center",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
                    }, [
                      _createElementVNode("i", _hoisted_12, _toDisplayString(_ctx.isPasswordVisible ? 'visibility_off' : 'visibility'), 1)
                    ]),
                    (_ctx.passwordError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.passwordError), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.confirmPasswordFieldType,
                      class: _normalizeClass(["form-control h-55", { 'is-invalid': _ctx.confirmPasswordError }]),
                      id: "confirmPassword",
                      placeholder: "Conferma password",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.passwordConfirmation) = $event)),
                      onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validatePasswordConfirmation && _ctx.validatePasswordConfirmation(...args))),
                      onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.validatePasswordConfirmation && _ctx.validatePasswordConfirmation(...args))),
                      required: ""
                    }, null, 42, _hoisted_15), [
                      [_vModelDynamic, _ctx.passwordConfirmation]
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("label", { for: "confirmPassword" }, "Conferma Password", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn border-0 position-absolute top-50 end-0 translate-middle-y d-flex align-items-center justify-content-center",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleConfirmPasswordVisibility && _ctx.toggleConfirmPasswordVisibility(...args)))
                    }, [
                      _createElementVNode("i", _hoisted_16, _toDisplayString(_ctx.isConfirmPasswordVisible ? 'visibility_off' : 'visibility'), 1)
                    ]),
                    (_ctx.confirmPasswordError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.confirmPasswordError), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-primary fw-medium py-2 px-3 w-100",
                      disabled: !_ctx.isFormValid || _ctx.isLoading
                    }, [
                      (_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[16] || (_cache[16] = [
                            _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[17] || (_cache[17] = [
                            _createElementVNode("i", { class: "material-symbols-outlined text-white fs-20 me-2" }, "lock_reset", -1),
                            _createElementVNode("span", null, "Cambia Password", -1)
                          ]))]))
                    ], 8, _hoisted_19)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "mb-4" }, [
                    _createElementVNode("i", {
                      class: "material-symbols-outlined text-success",
                      style: {"font-size":"4rem"}
                    }, "check_circle")
                  ], -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("p", { class: "mb-4" }, " Password cambiata con successo! Ora puoi effettuare il login con la nuova password. ", -1)),
                  _createVNode(_component_RouterLink, {
                    to: "/authentication/login",
                    class: "btn btn-primary fw-medium py-2 px-3"
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode(" Vai al Login ", -1)
                    ]))]),
                    _: 1
                  })
                ])),
            (!_ctx.resetCompleted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("p", _hoisted_24, [
                    _cache[22] || (_cache[22] = _createTextVNode(" Ti sei ricordato la password? ", -1)),
                    _createVNode(_component_RouterLink, {
                      to: "/authentication/login",
                      class: "fw-medium text-primary text-decoration-none"
                    }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createTextVNode(" Torna al Login ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 32)
        ])
      ])
    ])
  ]))
}